module.exports = __webpack_public_path__ + "img/bg1.83d73d31.png";